export default __webpack_public_path__ + "images/E8.b84ad4a.png";